import type { MouseEventHandler } from 'react';

import { Icon } from 'components/Icon/Icon';

import { StyledArrowButton } from './ArrowButton.styled';

type Props = {
  direction: 'left' | 'right';
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

export function ArrowButton({ direction, onClick, disabled }: Props) {
  return (
    <StyledArrowButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        paddingLeft: direction === 'left' ? 0 : 2,
        paddingRight: direction === 'right' ? 0 : 2,
      }}
    >
      <Icon
        name={direction === 'left' ? 'chevron-left' : 'chevron-right'}
        size={24}
        colorName="white"
      />
    </StyledArrowButton>
  );
}
